export default __webpack_public_path__ + "static/media/berrysorbet@2x.83e9826c.jpg";